interface scrollData {
    top?: number;
    height?: number;
    scrollTop?: number;
    scrollHeight?: number;
    maxScrollTop?: number;
}
export class DragScroll {
    scrollDom: HTMLElement;
    scrollSpeed = 10;
    scrollDomData: scrollData = {
        top: 0,
        height: 0,
        scrollTop: 0,
        scrollHeight: 0,
        maxScrollTop: 0,
    };
    yScrollKey = 0;
    yEventFlag = false;
    outRange = -1; // 0 上滚，1 下滚 2 左滚 3 右滚
    watchFunc: Function;

    constructor(dom: HTMLElement) {
        this.scrollDom = dom;
        this.watchFunc = new Function();
    }

    bindWatch() {
        this.watchFunc = this.watchMove.bind(this);
        document.addEventListener("mousemove", this.watchFunc as any);
        this.resetScroll();
    }

    removeWatch() {
        document.removeEventListener("mousemove", this.watchFunc as any);
        this.resetScroll();
    }

    resetScroll() {
        this.outRange = -1;
        this.yEventFlag = false;
        cancelAnimationFrame(this.yScrollKey);
    }

    watchMove(ev: MouseEvent) {
        const moveT = ev.clientY;
        if (moveT < this.scrollDomData.top!) {
            this.getSpeed(this.scrollDomData.top! - moveT);
            this.outRange = 0;
        } else if (moveT > this.scrollDomData.top! + this.scrollDomData.height!) {
            this.getSpeed(moveT - this.scrollDomData.top! - this.scrollDomData.height!);
            this.outRange = 1;
        } else {
            this.resetScroll();
            return;
        }

        if (this.outRange != -1 && !this.yEventFlag) {
            this.startScroll();
        }
    }

    getSpeed(offset: number) {
        const baseSpeed = 50;
        offset = offset > 200 ? 200 : offset;
        this.scrollSpeed = baseSpeed * Math.sin(((Math.PI / 2) * offset) / 200);
    }

    updateScrollDomData(data: any) {
        const keys = Object.keys(data);
        for (const item of keys) {
            (this.scrollDomData as any)[item] = data[item];
        }
    }

    scrollTop() {
        let height = this.scrollDomData.scrollTop! - this.scrollSpeed;
        height = height <= 0 ? 0 : height;
        this.scrollDom.scrollTo(0, height);
        this.updateScrollDomData({
            scrollTop: height,
            scrollHeight: this.scrollDom.scrollHeight, // 懒加载容器滚动高度会变化
        });
        this.yScrollKey = requestAnimationFrame(this.scrollTop.bind(this));
    }

    scrollBottom() {
        this.scrollDomData.maxScrollTop = this.scrollDomData.scrollHeight! - this.scrollDomData.height!;
        let height = this.scrollDomData.scrollTop! + this.scrollSpeed;
        height = height > this.scrollDomData.maxScrollTop ? this.scrollDomData.maxScrollTop : height;
        this.scrollDom.scrollTo(0, height);
        this.updateScrollDomData({
            scrollTop: height,
            scrollHeight: this.scrollDom.scrollHeight, // 懒加载容器滚动高度会变化
        });
        this.yScrollKey = requestAnimationFrame(this.scrollBottom.bind(this));
    }

    startScroll() {
        if (this.outRange == 0) {
            this.yEventFlag = true;
            this.yScrollKey = requestAnimationFrame(this.scrollTop.bind(this));
        } else if (this.outRange == 1) {
            this.yEventFlag = true;
            this.yScrollKey = requestAnimationFrame(this.scrollBottom.bind(this));
        }
    }
}
